
export default {
    namespaced: true,
    state: {
        data: {},
        showingSidebar: false
    },
    mutations: {
        _change(state, payload) {
            state.showingSidebar = payload.show;
            state.data = payload.data || {};
        },
        _set(state, data) {
            state.data = data;
        }
    },
    getters: {
        isShowing: state => {
            return  state.showingSidebar;
        },
        getData: state => {
            return  state.data || {};
        }
    },
    actions: {
        // setData({commit}, data) {
        //     commit('_set', data);
        // },
        hide({commit}) {
            commit('_change', {show: false, data: {}});
        },
        show({commit}, data = {}) {
            commit('_change', {show: true, data: data});
        }
    }

};
